const config = {
    build_number: '615745',
    build_timestamp: '2026-09-01T19:26:11.967Z',
    build_commit: '75d0c25e783f6637500267c464e1afe8dd2ff235',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
